// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__CNS6d"};